module.exports = {
    mqtt_brokerUrl: 'wss://dync.org:9001'
};
